var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 3,
    width: 16,
    height: 18,
    rx: 2,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M8 17H16",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2154 6.98783C11.3628 6.68912 11.667 6.5 12.0001 6.5C12.3332 6.5 12.6374 6.68912 12.7848 6.98783L13.23 7.89031C13.3574 8.14861 13.6038 8.32766 13.8888 8.36909L14.8847 8.51384C15.2142 8.56176 15.4879 8.79256 15.5909 9.10922C15.6938 9.42588 15.6081 9.77353 15.3698 10.006L14.6488 10.7092C14.4428 10.9102 14.3487 11.1998 14.3974 11.4835L14.5675 12.4751C14.6238 12.8033 14.4889 13.1351 14.2195 13.3308C13.9501 13.5266 13.5929 13.5524 13.2981 13.3975L12.4072 12.9293C12.1523 12.7954 11.8479 12.7954 11.593 12.9293L10.7021 13.3975C10.4073 13.5524 10.0502 13.5266 9.78075 13.3308C9.51135 13.1351 9.37643 12.8033 9.4327 12.4751L9.60281 11.4835C9.65148 11.1998 9.55746 10.9102 9.35137 10.7092L8.63046 10.006C8.39212 9.77353 8.3064 9.42588 8.40934 9.10922C8.51228 8.79256 8.78603 8.56176 9.11554 8.51384L10.1114 8.36909C10.3964 8.32766 10.6428 8.14861 10.7702 7.89031L11.2154 6.98783Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityTicket);
export default __webpack_public_path__ + "static/media/community-ticket.a898a204635175aeaa2318254badec92.svg";
export { ForwardRef as ReactComponent };